import axios from "axios";
import Swal from 'sweetalert2';

const state = {
  absentList: [], 
  absentArr: [],
  absentArray: [],
  absentID: '',
  selectedAbsent: null,
  selectedLedger: null,
  isEditing: false
};
  
const mutations = {
  initializeStore(state){
    state.absentList = [];
    state.absentArr = [];
    state.absentArray = [];
    state.absentID = "";
    state.selectedAbsent = null;
    state.selectedLedger = null;
    state.isEditing = false;
  },
  SET_SELECTED_ABSENTEEISM(state, Absent) {
    state.selectedAbsent = Absent;
    state.isEditing = true;
  },
  LIST_ABSENTEEISMS(state, Absents) {
    state.absentList = Absents;
  },
  ABSENTEEISM_ARRAY(state, Absents){
    state.absentArray = Absents;
  },
  SET_SELECTED_LEDGER(state, ledger) {
    state.selectedLedger = ledger;
  },
  SET_STATE(state, payload) {
    for (const key in payload) {
        if (payload.hasOwnProperty(key) && key in state) {
            state[key] = payload[key];
        }
    }
  },
  SET_SEARCH_FILTERS(state, search_filter){
    for(const [key, value] of Object.entries(search_filter)){
    }
  },
  RESET_SEARCH_FILTERS(state){

  }
};
  
const actions = {
  updateState({ commit }, newState) {
    commit('SET_STATE', newState);
  },
  
  async createAbsenteeism({ commit,state }, formData) {
    return axios.post('api/v1/create-absenteeism/', formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })
  },

  fetchAbsenteeisms({ commit,state }, formData) {
    state.absentArr = [];
    axios.post(`api/v1/get-absenteeisms/`,formData)
    .then((response)=>{
      for(let i=0; i< response.data.length; i++){
        state.absentArr.push((response.data[i].name));
      }
      commit('LIST_ABSENTEEISMS', response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  fetchAbsenteeism({ commit,state }, formData) {
    axios.post(`api/v1/get-absenteeisms/`,formData)
    .then((response)=>{
      state.selectedAbsent = response.data;
      const selectedLedger = response.data.posting_account.ledger_code + " - " + response.data.posting_account.ledger_name;
      commit('SET_SELECTED_ABSENTEEISM',response.data);
      commit('SET_SELECTED_LEDGER', selectedLedger);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  handleSelectedAbsenteeism({ commit, state }, option){
    const selectedAbsent = state.absentList.find(absent => (absent.name) === option);
    if (selectedAbsent) {
        state.absentID = selectedAbsent.absenteeism_id;
        selectedAbsent.employee_absenteeism_id = null;
        state.absentArray = [...state.absentArray, selectedAbsent];
    }
    commit('ABSENTEEISM_ARRAY', state.absentArray);
      
  },

  async updateAbsenteeism({ commit,state }, formData) {
    return axios.put(`api/v1/update-absenteeism/`,formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })  
  },

  deleteAbsenteeism({ commit,state }, formData) {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you wish to delete Absenteeism?`,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes Delete Absenteeism!',
      cancelButtonText: 'Cancel!',
      customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom',
      },
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.value) {
        axios.post(`api/v1/delete-absenteeism/`,formData)
        .then((response)=>{
          if(response.status == 200){
              Swal.fire("Poof! Absenteeism removed succesfully!", {
                icon: "success",
              }); 
          }else{
            Swal.fire({
              title: "Error Deleting Absenteeism",
              icon: "warning",
            });
          }                   
        })
        .catch((error)=>{
          console.log(error.message);
          Swal.fire({
            title: error.message,
            icon: "warning",
          });
        })
      }else{
        Swal.fire(`Absenteeism has not been deleted!`);
      }
    })
  },
  removeAbsenteeism({commit, state}, index){
    state.absentArray.splice(index, 1); 
    commit('ABSENTEEISM_ARRAY', state.absentArray);
  },
};
  
const getters = {
  // users: (state) => state.users,
  // currentUser: (state) => state.currentUser,
};
  
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  
  